import { Box, Card, CardContent, Grid, TextField, Typography } from "@mui/material"
import { ScrollableDialogProps } from "../Dialogs"
import { useFetchMotivos } from "../../../actions/erp";
import CustomAutocompleteMultipleArrStringNoForm from "../CustomAutocompleteMultipleArrStringNoForm";
import { ModulosMotivoENUM } from "../../../constants";
import { useEffect, useState } from "react";
import { boolean } from "yup";
import { useAuthStore } from "@/store/auth";
import { useUiStore } from "@/store/ui";
import { AlertSeverityEnum, EstadoMotivoEnum, IDataBitacoraRespById } from "../../../interfaces";
import { AnimatePresence, motion } from "framer-motion";

import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";

interface motivo {
  numero_referencia_motivo: string;
  nombre: string;
  prioridad: string;
  comentarios: comentario[];
}
interface comentario {
  comentario: string;
  username: string;
  rol: string;
  departamento?: string;
}
const BitacoraDialog = () => {
  ///hook
  const {
    openCreaBitacora,
    setOpenCreaBitacora,
    detalle,
    fase_venta,
    selectedMotivos,
    setSelectedMotivos,
    emitGetVentaById,
    departamento: depSocket,
    socket
  } = useDiccionarioMotivo()


  const username = useAuthStore.getState().user?.username ?? '';
  const rol = useAuthStore(s => s.user)?.rol!
  const departamento = useAuthStore(s => s.user)?.departamento!

  ///const [selectedMotivos, setSeletedMotivos] = useState<motivo[]>([]);
  const [comentarios, setComentarios] = useState<{ [key: string]: comentario[] }>({});

  const setAlert = useUiStore.getState().setAlert;

  const { data: dataMotivos, isLoading: isLoadingMotivo
  } = useFetchMotivos({
    estado: true,
    modulo_in: `${ModulosMotivoENUM.BITACORA_VENTA},${ModulosMotivoENUM.BITACORA_PYL}`,
    page_size: 256,
  })

  ///limpia al desmontar
  useEffect(() => {
    if (!openCreaBitacora) {
      setSelectedMotivos([])
      setComentarios({})
    }
  }, [openCreaBitacora])

  // Pre-cargar motivo y comentario del técnico si existe observación de rechazo
  useEffect(() => {
    if (openCreaBitacora && detalle?.observacion_rechazo_tecnico && dataMotivos?.data?.data) {
      // Seleccionar motivo según tipo_novedad: FALLA → FALLIDO, RE_COORDINAR → RECORDINADO
      const esRecoordinacion =
        detalle.tipo_novedad === 'RE_COORDINAR' ||
        detalle.estado_agendamiento === 'RECORDINADO';
      const motivoCodigo = esRecoordinacion
        ? 'RECORDINADO_PLANTA_EXTERNA_PYL'
        : 'FALLIDO_PLANTA_EXTERNA_PYL';

      const motivoEncontrado = dataMotivos.data.data.find(
        (m: any) => m.codigo === motivoCodigo && m.modulo === depSocket
      );
      if (motivoEncontrado && selectedMotivos.length === 0) {
        const motivoPreseleccionado = {
          numero_referencia_motivo: motivoEncontrado.id_motivo,
          nombre: motivoEncontrado.nombre,
          prioridad: motivoEncontrado.prioridad,
          modulo: motivoEncontrado.modulo,
          comentarios: []
        };
        setSelectedMotivos([motivoPreseleccionado]);
        const textoComentario = detalle.motivo_rechazo_tecnico
          ? `Motivo: ${detalle.motivo_rechazo_tecnico} - ${detalle.observacion_rechazo_tecnico}`
          : detalle.observacion_rechazo_tecnico;
        setComentarios({
          [motivoEncontrado.id_motivo]: [{
            comentario: textoComentario,
            username,
            rol,
            departamento,
          }]
        });
      }
    }
  }, [openCreaBitacora, dataMotivos, detalle])
  //
  const onsave = () => {
    const comentariosIncompletos = selectedMotivos.some((motivo) => {
      const comentario = comentarios[motivo.numero_referencia_motivo]?.[comentarios[motivo.numero_referencia_motivo].length - 1]?.comentario;
      return !comentario || comentario.trim() === '';
    });

    if (comentariosIncompletos) {
      setAlert(true, 'El campo comentario, es obligatorio', AlertSeverityEnum.error);
      return;
    }
    const venta = {
      ...detalle,
      creado_por: username,
      fase_venta: fase_venta,
      motivos: selectedMotivos.map((motivo) => ({
        numero_referencia_motivo: motivo.numero_referencia_motivo,
        descripcion: motivo.nombre,
        prioridad: motivo.prioridad,
        estado_motivo: EstadoMotivoEnum.NO_RESUELTO,
        modulo: motivo.modulo,
        comentarios: comentarios[motivo.numero_referencia_motivo] || [],
      }))
    }

    console.log(venta, 'create venta');

    if (!socket) return

    socket.emit('createVenta', { ventaData: venta }, (response: IDataBitacoraRespById) => {

      if (response?.code == 200) {
        setAlert(true, response.message, AlertSeverityEnum.success)
        setOpenCreaBitacora(false)
        emitGetVentaById(response.data.numero_referencia_venta)
      } else {
        setAlert(true, 'Error al crear la venta', AlertSeverityEnum.error)
      }
    })

  }
  const handleMotivoChange = (value: string | string[]) => {
    const motivosNombres = Array.isArray(value) ? value : [value]
    const motivosSelecionados = motivosNombres.map(nombre => {
      const motivo = dataMotivos?.data.data.find(elemento => elemento.nombre === nombre)
      return motivo ? {
        numero_referencia_motivo: motivo.id_motivo,
        nombre: motivo.nombre,
        prioridad: motivo.prioridad,
        modulo: motivo.modulo,
        comentarios: []
      } : null
    }).filter(boolean) as motivo[]

    ///limpiar los comentarios
    setComentarios(prevComentarios => {
      const nuevosComentarios: { [key: string]: comentario[] } = {}
      motivosSelecionados.forEach(motivos => {
        if (prevComentarios[motivos.numero_referencia_motivo]) {
          nuevosComentarios[motivos.numero_referencia_motivo] = prevComentarios[motivos.numero_referencia_motivo];
        }
      });
      return nuevosComentarios
    })
    setSelectedMotivos(motivosSelecionados)

  }

  const handleComentario = (id_motivo: string, value: any) => {
    setComentarios((prevComentarios) => {
      const comentarios = [
        {
          comentario: value,
          username: username,
          rol: rol,
          departamento: departamento,
        },
      ];
      return {
        ...prevComentarios, ////permite para escribir nuevo mensaje sin perder lo anterior
        [id_motivo]: comentarios
      }
    })
  }

  const getMotivoNombre = (codigo: string) => {
    const motivo = dataMotivos?.data.data.find((item) => item.codigo === codigo);
    return motivo ? motivo.nombre : codigo;
  }

  return (
    <ScrollableDialogProps
      open={openCreaBitacora}
      onCloseIcon={() => setOpenCreaBitacora(false)}
      title="Creación de Bitacora"
      minWidth="65%"
      confirmBtnColor="primary"
      confirmTextBtn="Crear"
      confirmVariantBtn="contained"
      showConfirmBtn
      onConfirm={onsave}
      contentNode={
        <>
          <Grid container spacing={1} alignItems={"center"} mb={3}>
            <CustomAutocompleteMultipleArrStringNoForm
              label="Motivo bitácora"
              name="motivo"
              textFieldKey="codigo"
              defaultValue={[]}
              options={dataMotivos?.data?.data?.filter(e => e.modulo === depSocket).map(item => item.nombre) || []}
              isLoadingData={isLoadingMotivo}
              helperText={undefined}
              disabled={false}
              enableStringify={false}
              onChangeValue={value => handleMotivoChange(value)}
            />
          </Grid>
          <Box display={"flex"} flexDirection={"column"} gap={2}
          >
            <AnimatePresence>
              {selectedMotivos.map((motivo) => (
                <motion.div
                  key={motivo.numero_referencia_motivo}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  <Card variant="outlined" sx={{ mb: '4', boxShadow: 0.1, transition: 'box-shadow 0.3s' }}>
                    <CardContent >
                      <Typography fontWeight="bold">{getMotivoNombre(motivo.nombre)} *</Typography>

                      <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>

                        <TextField
                          label="Comentario *"
                          variant="standard"
                          multiline
                          fullWidth
                          rows={1}
                          value={comentarios[motivo.numero_referencia_motivo]?.[comentarios[motivo.numero_referencia_motivo]?.length - 1]?.comentario || ''}
                          onChange={(e) => { handleComentario(motivo.numero_referencia_motivo, e.target.value) }}

                        />

                      </Box>

                    </CardContent>

                  </Card>

                </motion.div>
              ))}
            </AnimatePresence>

          </Box>

        </>
      }
    />
  )
}
export default BitacoraDialog;